import React from "react";
import DynamicTable2 from "../../components/DynamicTable2";

const PensionForm6 = ({ formData, setFormData, onBack, onFormDataChange, onSubmit }) => {
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const onTableDataChange = (key) => (rows) => {
    setFormData((prevState) => ({
      ...prevState,
      [key]: rows,
    }));
  };

  // Individual property fallbacks
  const getSafeValue = (key) => {
    return formData?.[key] ?? '';
  };

  return (
    <div className="google_forms">
      <div className="forms">
        <form>
          <h3>Last Month Salary Details</h3>
          <label>
            Pay Level:
            <select 
              name="payLevel" 
              value={getSafeValue('payLevel')} 
              onChange={handleInputChange}
            >
              <option value="">Select Pay Level</option>
              {[
                "S-1", "S-2", "S-3", "S-4", "S-5", "S-6", "S-7", "S-8", "S-9", "S-10", 
                "S-11", "S-12", "S-13", "S-14", "S-15", "S-16", "S-17", "S-18", "S-19", 
                "S-20", "S-21", "S-22", "S-23", "S-24", "S-25", "S-26", "S-27", "S-28", 
                "S-29", "S-30", "S-31", "AL-10", "AL-11", "AL-12", "AL-13A", "AL-14", "AL-15"
              ].map(level => (
                <option key={level} value={level}>{level}</option>
              ))}
            </select>
          </label>

          <DynamicTable2
            tableName="Pensionable Pay: (Last 10 Months)"
            columns={[
              { header: "From", key: "from", type: "date" },
              { header: "To", key: "to", type: "date"},
              { header: "Basic Pay Rate", key: "payrate", type: "number"},
            ]}
            localStorageKey="payrateTable"
            rows={formData?.payrateTable || []}  
            onTableDataChange={onTableDataChange("payrateTable")}
          />        

          <label>
            Last Month Basic Pay:
            <input 
              type="number" 
              name="basicPay" 
              value={getSafeValue('basicPay')} 
              onChange={handleInputChange} 
            />
          </label>
           <label>
            Notional Pay:
            <input 
              type="number" 
              name="notionalPay" 
              value={getSafeValue('notionalPay')} 
              onChange={handleInputChange} 
            />
          </label>
        
          <label>
            DA:
            <input 
              type="number" 
              name="DA" 
              value={getSafeValue('DA')} 
              onChange={handleInputChange} 
            />
          </label>

          <label>
            HRA:
            <input 
              type="number" 
              name="HRA" 
              value={getSafeValue('HRA')} 
              onChange={handleInputChange} 
            />
          </label>

          <label>
            TRA:
            <input 
              type="number" 
              name="TRA" 
              value={getSafeValue('TRA')} 
              onChange={handleInputChange} 
            />
          </label>

          <label>
            CLA:
            <input 
              type="number" 
              name="CLA" 
              value={getSafeValue('CLA')} 
              onChange={handleInputChange} 
            />
          </label>
          
          <label>
            Special Pay:
            <input 
              type="number" 
              name="splPay" 
              value={getSafeValue('splPay')} 
              onChange={handleInputChange} 
            />
          </label>

          <button type="button" onClick={onBack}>Back</button>
          <button type="button" className="submit-button" onClick={onSubmit}>
            Submit
          </button>
        </form>
      </div>
    </div>
  );
};

export default PensionForm6;